import { getCommonJsonIdData } from '../Common/commonUtils';

export const SHAKEY = 'Tectoro@123_Implify_GGH';

// COMMON JSON DATA PARAMETER NAMES
export const TimeZones = 'TimeZones';
export const PREDEFINED_TAGS = 'PREDEFINED_TAGS';
export const showAssessments = 'showAssessments';
// ASSESSMENT CONSTANTS
export const CCCHealth = 'CCC Health';
export const CCCSDOH = 'CCC SDOH';
export const Telehealth = 'Telehealth';
export const ADLTEMPLATE = 'ADLTEMPLATE';
export const pcpAssessmentTitle = 'PCP_Info';
export const pcpConnectAssTitle = 'PCP Connect_Info';
export const H2H90DaySatisfactionSurvey = 'H2H- 90-day Satisfaction Survey_Info';
export const H2HCGBurden = 'H2H CG Burden_Info';
export const H2HLivingPlans = 'H2H Living Plans_Info';
export const H2HMOCA = 'H2H MOCA_Info';
export const H2HQOLAD = 'H2H QOL-AD_Info';
export const H2HReferralForm = 'H2H Referral Form_Info';
export const H2HRegistrationForm = 'H2H Registration Form_Info';
export const H2HRespiteCoachDailyClient = 'H2H Respite Coach Daily Client Report_Info';
export const H2HRespiteCoach = 'H2H Respite Coach Report_Info';
export const H2HRespiteContactNote = 'H2H Respite Contact Note_Info';
export const H2HKatzADLs = 'H2H Katz ADLs_Info';
export const CervicalCancerScreenerInfo = 'Cervical_Cancer_Screener_Info';
export const VOAAsthmaTitle = 'VOA_Asthma_Info';
export const KYMaternalHealthtemplate = 'KY_Maternal_Health_template';
export const CRCtemplate = 'CRCtemplate';
export const AIHSHRSN = 'AHC-HRSN_Assessment_Info';
export const WIMA1C = 'WI-M A1C';
export const WinconsinSDOH = 'Wisconsin-Medicaid-SDOH';
export const CAMCOMBO10WellChildGSD = 'CA-M COMBO10-WellChild-GSD';
export const WIMWellChild = 'WI-M Well Child';
export const CA_HEDIS = 'CA-HEDIS';
export const BCS_COL = 'BCS-COL';
export const WNYHIV = 'WNY HIV';
export const PDTEAssmt = 'PDS-E: Postpartum Depression Screening';
export const SOGIAssmt = 'SOGI';
export const prapareFormType = 'PRAPARE_Info';
export const DiabetesLatinx = 'Diabetes Latinx';
export const PHQ2template = 'PHQ2template';
export const ADL = 'ADL';
export const IADL = 'IADL';
export const FallRiskAssessment = 'Fall Risk Assessment';
export const NutritionAssessment = 'Nutrition Assessment';
export const PHQ9Template = 'PHQ9 template';
export const SRM = 'SRM';
export const GAMPrenatal = 'GA-M Prenatal';
export const CGMonitor = 'CG MONITOR';
export const CMSDOHInfoTitle = 'CM-SDOH_Info';
export const HealthLiteracy = 'Health Literacy';
export const ExtendedCarefollowup = 'Extended Care followup';
export const comboVaccinationAssmt = 'VACCINATION ASSESSMENT_Info';
export const PHQ2 = 'PHQ2';

export const referralStatisSuspended = 'Suspended';
export const referralStatisRejected = 'Rejected';
export const StatusAbonded = 'Abandoned';

// Title Object
export const TitleObject = {
    'WNY HIV': 'Member must be verified before reading the following',
    'BCS-COL': 'MEMBER’S IDENTITY MUST HAVE BEEN VERIFIED BEFORE CONTINUING TO READ THE QUESTIONS BELOW'
};

export const measureBasedOnCohort = {
    'BCS-COL': ['Breast Cancer Screening', 'Colorectal Cancer Screening']
};

export const ReferralStatusTooltip = {
    Unassigned: 'The referral has been received but not yet assigned to a Care Coordinator.',
    Outreach: 'Initial contact with the member is in progress. Ensure you document all outreach attempts.',
    Assessment: 'The referral is in the assessment phase. Prepare and gather information to conduct an assessment.',
    'Assessment InProgress': 'The assessment is currently being conducted. Continue gathering and recording necessary information.',
    'Assessment Completed': 'The assessment has been finalized and submitted.',
    Fulfilment: 'Services identified in the assessment are being arranged and delivered to the member.'
};

export const headerMenuItems = (tenant) => {
    const isAssessmentsAvailable = getCommonJsonIdData(showAssessments)?.[tenant] || false;
    const data = [
        {
            id: 2,
            label: 'Care Plan',
            link: '/careplan'
        }
    ];
    if (isAssessmentsAvailable) {
        data.unshift({
            id: 1,
            label: 'Assessments',
            link: '/assessments'
        });
    }
    return data;
};
// UHC Constants
export const UHCNYSourceId = 17;
export const refTypePCP = 'PCP';
export const viewUploadFileId = 16;
export const downloadUploadFileId = 4;
export const showFulfillmentUploadButtonIds = 'showFulfillmentUploadButtonIds';
export const MiniTemplateULTypeForFulfillmentUpload = 'ul';
export const MiniTemplateNormalTypeForFulfillmentUpload = 'normal';
export const MiniTempNorTypeForFulfiUpCheckForDocUploaded = 'normal-checkForDocumentUploaded';
export const download = 4;
export const view = 16;
export const stepLanguageCodes = 'stepLanguageCodes';
export const dateCutOffForTheFulfillment = 'dateCutOffForTheFulfillment';
export const fulfillmentNoQuesContent = 'fulfillmentNoQuesContent';
